import React from 'react'
import PropTypes from 'prop-types'

const CoreFormLayout = ({
  children,
  className = '',
  flexDirection = 'row',
  justifyContent = 'flex-start',
  alignItems = 'stretch',
  width = '100%',
  itemsPerRow = 1, // Number of items per row
  itemGap = '16px', // Space between items
  backgroundColor = 'transparent',
  ...props
}) => {
  const itemWidth = `calc(${100 / itemsPerRow}% - ${itemGap})`

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: flexDirection === 'column' ? 'column' : 'row',
        flexWrap: flexDirection === 'row' ? 'wrap' : 'nowrap',
        justifyContent: justifyContent,
        alignItems: alignItems,
        width: width,
        gap: itemGap,
        backgroundColor: backgroundColor,
      }}
      {...props}
    >
      {React.Children.map(children, child => (
        <div
          style={{
            width: flexDirection === 'column' ? '100%' : itemWidth,
            flexBasis: itemWidth,
          }}
        >
          {child}
        </div>
      ))}
    </div>
  )
}

CoreFormLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  flexDirection: PropTypes.oneOf(['row', 'column']),
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  width: PropTypes.string,
  itemsPerRow: PropTypes.number,
  itemGap: PropTypes.string,
}

export default CoreFormLayout
